import { render, staticRenderFns } from "./APActivityChart.vue?vue&type=template&id=af023650&"
import script from "./APActivityChart.vue?vue&type=script&lang=js&"
export * from "./APActivityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports